// extracted by mini-css-extract-plugin
module.exports = {"toggleWrapper":"BuyOnline_toggleWrapper__1c95w","tooltip":"BuyOnline_tooltip__fNZxp","tooltipText":"BuyOnline_tooltipText___xSIc"};